(function ($) {

'use strict';

	/**
	 * Handles css switching for defined options.
	 */
	$.cssSwitcher = {
		/**
		 * indicates if cssSwitcher.init() was called
		 */
		initDone: false,
		/**
		 * initialize the switcher elements
		 * @param {string} cssOptionName
		 * @param {type} options
		 * @returns {undefined}
		 */
		init: function (options) {
			if (this.initDone) {
				console.log('<!> cssSwitcher.init() is not allowed to run more then one time!');
				return;
			}
			this.initDone = true;

			$.morejs_options.cssSwitchConfig = $.extend(true, $.morejs_options.cssSwitchConfig, (options || {}));

			var cookieData = $.cookieHelper.getCookie('csssw');

			// reset all css
			$('#csssw-reset').on('click', function () {
				$.cookieHelper.setCookie('csssw', '', -1);
				location.reload();
			});

			// get selected css names from cookie 'csssw'
			for (var switchOption in $.morejs_options.cssSwitchConfig.data) {
				var cssConf = $.morejs_options.cssSwitchConfig.data[switchOption].options;
				// check for current selected css
				var currSelection = switchOption + '-default';
				var pos = cookieData.indexOf(switchOption);
				if (pos > -1) {
					currSelection = cookieData.substr(pos + switchOption.length + 1);
					pos = currSelection.indexOf(',');
					pos = (pos > -1 ? pos : currSelection.length);
					currSelection = currSelection.substr(0, pos);
					currSelection = (currSelection ? currSelection : switchOption + '-default');
				}

				// set active selection for the current css option
				$.morejs_options.cssSwitchConfig[switchOption + '_active'] = currSelection;
				$('#' + currSelection).addClass('active');
				// process all options for the current selection
				var currentHandled = false;
				var usePrevNext = $.morejs_options.cssSwitchConfig.data[switchOption].addPrevNextClasses;
				var loadFunc = $.morejs_options.cssSwitchConfig.data[switchOption].load;
				var prev = '';
				for (var i = 0; i < cssConf.length; i++) {
					if (currSelection === cssConf[i]) {
						// add class for previous element
						if (usePrevNext && prev) {
							$('#' + prev).addClass('prev');
						}
						// add class for next element
						if (usePrevNext && (i + 1) < cssConf.length) {
							$('#' + cssConf[i + 1]).addClass('next');
						}
						// execute load() if declared
						if (loadFunc &&
								typeof loadFunc === 'function') {
							loadFunc(currSelection);
						}
						currentHandled = true;
					} else {
						if (!currentHandled && usePrevNext) {
							prev = cssConf[i];
						}
						// set click handler
						$('#' + cssConf[i]).on('click', function () {
							$.cssSwitcher.activateCss($(this));
							return false;
						});
					}
					$('#' + cssConf[i]).attr('data-cssswitch', switchOption);
				}
			}

			if (typeof $.morejs_options.cssSwitchConfig.initialized === 'function') {
				$.morejs_options.cssSwitchConfig.initialized();
			}
		},
		/**
		 * Set the cookie for the current selections and reload the page
		 * @param {jQuery} $switchElem clicked element
		 * @returns {undefined}
		 */
		activateCss: function ($switchElem) {
			if (!this.initDone) {
				console.log('<!> cssSwitcher.activateCss() could not exetcute before init() was called!');
				return;
			}

			var expires = 157680000000; // cookie expires in 5 years;

			$.morejs_options.cssSwitchConfig[$switchElem.attr('data-cssswitch') + '_active'] = $switchElem.attr('id');
			var cookieData = '';
			for (var switchName in $.morejs_options.cssSwitchConfig.data) {
				var activeName = $.morejs_options.cssSwitchConfig[switchName + '_active'];
				if (activeName && activeName !== switchName + '-default') {
					cookieData += (cookieData !== '' ? ',' : '') + switchName + '=' + activeName;
				}
			}
			// if empty request to delete the cookie
			if (cookieData === '') {
				expires = -1;
			}
			// set cookie and reload page
			$.cookieHelper.setCookie('csssw', cookieData, expires);
			location.reload();
		}
	}; // $.cssSwitcher

}(jQuery));